import { LOGIN, LOGOUT, CHECK_AUTH } from "../actions";

const initialState = {
  uid: "init",
  security: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case LOGIN:
      if (action.payload) {
        console.log("[AUTH REDUCER] LOGIN", action.payload.uid);
        return { security: state["security"], uid: action.payload.uid };
      } else {
        return state;
      }
    case LOGOUT:
      return { uid: "0", security: false };
    case CHECK_AUTH:
      if (action.payload) {
        console.log("[AUTH REDUCER] CHECK_AUTH", action.payload.uid);
        return { security: state["security"], uid: action.payload.uid };
      } else {
        return state;
      }
    default:
      return state;
  }
}
